import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ✅ Influencer Dashboard
export async function loadInfluencerDashboardApi(user_id) {
  try {
    const fd = new FormData();

    fd.append("user_id", user_id);

    const res = await axios.post(
      `${apiBaseUrl}influencerapis/dashboard`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return res.data;

  } catch {
    return { status: false };
  }
}

export async function sendBroadcastApi(user_id, payload,file) {

  try {

    const fd = new FormData();

    fd.append("user_id", user_id);
    fd.append("payload", JSON.stringify(payload));
    fd.append("myfile", file);

    const res = await axios.post(
      `${apiBaseUrl}influencerapis/send_broadcast`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;

  } catch {
    return { status: false };
  }
}

export const joinStartApi = async (influencer_id, form) => {
  try {
    const fd = new FormData();

    fd.append("influencer_id", influencer_id);
    fd.append("name", form.name);
    fd.append("email", form.email);
    fd.append("phone", form.phone);
    fd.append("password", form.password);

    const res = await fetch(
      `${apiBaseUrl}influencerapis/join_start`,
      {
        method: "POST",
        body: fd
      }
    );

    return await res.json();

  } catch (err) {
    return {
      status: false,
      success: "Network error"
    };
  }
};


export const getPublicProfileApi = async (username) => {
  try {

    const fd = new FormData();

    fd.append("username", username);

    const res = await fetch(
      `${apiBaseUrl}influencerapis/get_public_profile`,
      {
        method: "POST",
        body: fd
      }
    );

    return await res.json();

  } catch (err) {

    return {
      status: false,
      success: "Network error"
    };
  }
};

export const getAudienceKpisApi = async (user_id) => {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const res = await fetch(
      `${apiBaseUrl}influencerapis/get_audience_kpis`,
      { method: "POST", body: fd }
    );

    return await res.json();

  } catch {
    return { status:false, success:"Network error" };
  }
};

export const getAudienceListApi = async (user_id, page) => {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("page", page);

    const res = await fetch(
      `${apiBaseUrl}influencerapis/get_audience_list`,
      { method: "POST", body: fd }
    );

    return await res.json();

  } catch {
    return { status:false, success:"Network error" };
  }
};

export const getCampaignKpisApi = async (user_id) => {
  try {

    const fd = new FormData();
    fd.append("user_id", user_id);

    const res = await fetch(
      `${apiBaseUrl}influencerapis/get_campaign_kpis`,
      {
        method: "POST",
        body: fd
      }
    );

    return await res.json();

  } catch (err) {

    return {
      status: false,
      success: "Network error"
    };
  }
};

export const getCampaignListApi = async (user_id) => {
  try {

    const fd = new FormData();
    fd.append("user_id", user_id);

    const res = await fetch(
      `${apiBaseUrl}influencerapis/get_campaign_list`,
      {
        method: "POST",
        body: fd
      }
    );

    return await res.json();

  } catch (err) {

    return {
      status: false,
      success: "Network error"
    };
  }
};
export const getCampaignDetailsApi = async (cmp_id) => {
  try {

    const fd = new FormData();
    fd.append("cmp_id", cmp_id);

    const res = await fetch(
      `${apiBaseUrl}influencerapis/get_campaign_details`,
      {
        method: "POST",
        body: fd
      }
    );

    return await res.json();

  } catch (err) {

    return {
      status: false,
      success: "Network error"
    };
  }
};

export const acceptCampaignApi = async (cmp_id) => {
  try {

    const fd = new FormData();
    fd.append("cmp_id", cmp_id);

    const res = await fetch(
      `${apiBaseUrl}influencerapis/accept_campaign`,
      {
        method: "POST",
        body: fd
      }
    );

    return await res.json();

  } catch (err) {

    return {
      status: false,
      success: "Network error"
    };
  }
};
export const rejectCampaignApi = async (cmp_id, reason) => {
  try {

    const fd = new FormData();
    fd.append("cmp_id", cmp_id);
    fd.append("reason", reason);

    const res = await fetch(
      `${apiBaseUrl}influencerapis/reject_campaign`,
      {
        method: "POST",
        body: fd
      }
    );

    return await res.json();

  } catch (err) {

    return {
      status: false,
      success: "Network error"
    };
  }
};
export const updateVaultAccessApi = async (payload) => {
  try {

    const formData = new FormData();

    formData.append("user_id", payload.user_id);
    formData.append("audience_size", payload.audience_size);
    formData.append("engagement", payload.engagement);

    const res = await fetch(
      `${apiBaseUrl}influencerapis/update_access_controls`,
      {
        method: "POST",
        body: formData
      }
    );

    return await res.json();

  } catch (err) {
    return { status: false, success: "Network error" };
  }
};

export const getVaultDashboardApi = async (user_id) => {
  try {

    const formData = new FormData();
    formData.append("user_id", user_id);

    const res = await fetch(
      `${apiBaseUrl}influencerapis/get_vault_dashboard`,
      {
        method: "POST",
        body: formData
      }
    );

    return await res.json();

  } catch (err) {
    return { status: false, success: "Network error" };
  }
};




